import React from 'react'
import {useController} from 'react-hook-form'
import Input from 'Src/components/Input'
import {INPUT_NAMES, usePageContext} from 'Src/components/pages/SoftPull/PageContext'
import {trans} from 'Src/utilities/Helpers'

const Address = () => {
  const {control} = usePageContext()
  const {
    field,
    fieldState: {error},
  } = useController({
    control,
    name: INPUT_NAMES.ADDRESS,
  })

  return (
    <div className="tw-mb-6" id="register-address" aria-live="assertive" aria-atomic="false">
      <label htmlFor="address" className="required input-label tw-mb-2">
        {trans('address')}
      </label>
      <Input
        type="text"
        id="address"
        className="input-field tw-w-full"
        error={error?.message}
        autoComplete="shipping street-address"
        required
        aria-required="true"
        {...field}
      />
    </div>
  )
}

export default Address
